'use client';

import cn from 'classnames';
import { useDeviceYmm } from '@/hooks/useDeviceYmm';
import styles from './dualOfferComparisonTable.module.scss';

interface YmmBannerProps {
    student: string;
    tokenType: string;
}

export function YmmBanner({ student, tokenType }: YmmBannerProps) {
    const { ymm } = useDeviceYmm({ student, tokenType });
    if (!ymm) return null;
    return (
        <div className={cn(styles.ymmBanner, styles.ymmBannerFilled)}>
            <strong>{ymm.last4DigitsOfRadioId ? 'Radio ID: ' : 'Your vehicle: '}</strong>
            {ymm.last4DigitsOfRadioId
                ? `****${ymm.last4DigitsOfRadioId}`
                : [ymm.year, ymm.make, ymm.model].filter(Boolean).join(' ')}
        </div>
    );
}
